export const marketingGridContent = [
    {
        image: {
            src: 'v1578953699/employer/marketing/female_leaders.jpg',
            alt: 'unlimited-job-posts',
        },
        content: {
            label: 'Unlimited Job Posts',
            title: 'Drive Female Candidates to Your Website',
            description:
                'Optimize the visibility to your open positions. Our unlimited job postings and personalized email alerts ensure that more women see and apply to your open jobs.',
        },
    },
    {
        image: {
            src: 'v1578953699/employer/marketing/company_benefits.jpg',
            alt: 'company-benefits',
        },
        content: {
            label: 'Company Benefits',
            title: 'Highlight Company Benefits That Women Care About',
            description:
                'Whether it’s generous maternity leave, flexible work schedules, caregiver policies or a strong 401(k) program, feature the  benefits that appeal to women most.',
        },
    },
    {
        image: {
            src: 'v1578953699/employer/marketing/unlimited_job_posts.jpg',
            alt: 'female-leaders',
        },
        content: {
            label: 'Female Leaders',
            title: 'Showcase Your Female Role Models',
            description:
                '70% of female job seekers want to know if a company has female leaders. Use your Employer Profile to showcase female role models and help millions of women envision working with you.',
        },
    },
];
